/* Collection directory: follow the animated header and smooth only its group links. */
(function () {
  'use strict';
  if (window.c4uDirectoryNavigation) {
    window.c4uDirectoryNavigation.init(document);
    return;
  }
  var controllers = new Map();
  var selector = '.custom-cll4v7--showcase';

  function mount(root) {
    if (controllers.has(root)) return;
    var rail = root.querySelector('.custom-cll4v7__jump');
    if (!rail) return;
    var menu = document.querySelector('[data-mm]');
    var header = menu ? menu.closest('.shopify-section') : null;
    var frame = 0;
    var followUntil = 0;
    var disposed = false;
    var listeners = [];
    var observers = [];
    var focusRestorers = [];
    var selectedLink;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    var entries = Array.prototype.map.call(rail.querySelectorAll('.custom-cll4v7__jump-link'), function (link) {
      var target = null;
      try { target = document.getElementById(decodeURIComponent(link.hash.slice(1))); } catch (error) { /* Keep invalid links native. */ }
      return { link: link, target: target && root.contains(target) ? target : null, wasOn: link.classList.contains('is-on'), current: link.getAttribute('aria-current') };
    });
    var prior = ['--directory-header-visible', '--directory-rail-height'].map(function (name) {
      return { name: name, value: root.style.getPropertyValue(name), priority: root.style.getPropertyPriority(name) };
    });

    function listen(target, type, fn, options) {
      if (!target) return;
      target.addEventListener(type, fn, options);
      listeners.push(function () { target.removeEventListener(type, fn, options); });
    }
    function writeLength(name, value, width) {
      var text = (value / width * 100).toFixed(6) + 'vw';
      if (root.style.getPropertyValue(name) !== text) root.style.setProperty(name, text);
    }
    function select(link) {
      if (selectedLink === link) return;
      selectedLink = link;
      entries.forEach(function (entry) {
        var active = entry.link === link;
        entry.link.classList.toggle('is-on', active);
        if (active) entry.link.setAttribute('aria-current', 'location');
        else entry.link.removeAttribute('aria-current');
      });
    }
    function syncCurrent() {
      var current = null;
      var railBottom = rail.getBoundingClientRect().bottom;
      entries.forEach(function (entry) {
        if (!entry.target) return;
        if (!current) current = entry.link;
        /* Match the same header/rail clearance used for anchor landing, including upward travel. */
        var line = Math.max(railBottom, parseFloat(getComputedStyle(entry.target).scrollMarginTop) || 0);
        if (entry.target.getBoundingClientRect().top <= line + 1) current = entry.link;
      });
      select(current);
    }
    function sync(now) {
      frame = 0;
      if (disposed || !root.isConnected) return;
      var width = window.innerWidth || document.documentElement.clientWidth;
      var visible = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var height = rail.getBoundingClientRect().height;
      writeLength('--directory-header-visible', visible, width);
      writeLength('--directory-rail-height', height, width);
      syncCurrent();
      if (now < followUntil) frame = requestAnimationFrame(sync);
    }
    function queue() { if (!disposed && !frame) frame = requestAnimationFrame(sync); }
    function follow() { followUntil = performance.now() + 650; queue(); }
    function transition(event) {
      if (event.target === header && event.propertyName === 'transform') follow();
    }
    function focusTarget(target) {
      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
        var restore = function () {
          target.removeEventListener('blur', restore);
          if (target.getAttribute('tabindex') === '-1') target.removeAttribute('tabindex');
          var index = focusRestorers.indexOf(restore);
          if (index !== -1) focusRestorers.splice(index, 1);
        };
        target.addEventListener('blur', restore);
        focusRestorers.push(restore);
      }
      target.focus({ preventScroll: true });
    }
    listen(window, 'scroll', queue, { passive: true });
    listen(window, 'resize', follow, { passive: true });
    listen(window, 'load', follow);
    listen(window, 'pageshow', follow);
    listen(header, 'transitionrun', transition);
    listen(header, 'transitionend', transition);
    listen(header, 'transitioncancel', transition);
    if ('MutationObserver' in window && header) {
      var headerState = new MutationObserver(follow);
      headerState.observe(header, { attributes: true, attributeFilter: ['class'] });
      headerState.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      observers.push(headerState);
    }
    if ('ResizeObserver' in window) {
      var size = new ResizeObserver(follow);
      size.observe(rail);
      if (header) size.observe(header);
      observers.push(size);
    }

    listen(rail, 'click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target.closest('.custom-cll4v7__jump-link');
      if (!link || !rail.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) !== '#') return;
      var id;
      try { id = decodeURIComponent(href.slice(1)); } catch (error) { return; }
      var target = document.getElementById(id);
      if (!target || !root.contains(target)) return;
      event.preventDefault();
      cancelAnimationFrame(frame);
      sync(performance.now());
      select(link);
      /* Reserve full header height in scroll-margin for upward clicks that reveal it. */
      target.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      if (location.hash !== href) history.pushState(null, '', href);
      focusTarget(target);
    });
    sync(performance.now());
    controllers.set(root, function () {
      disposed = true;
      cancelAnimationFrame(frame);
      listeners.forEach(function (remove) { remove(); });
      observers.forEach(function (observer) { observer.disconnect(); });
      focusRestorers.slice().forEach(function (restore) { restore(); });
      entries.forEach(function (entry) {
        entry.link.classList.toggle('is-on', entry.wasOn);
        if (entry.current === null) entry.link.removeAttribute('aria-current');
        else entry.link.setAttribute('aria-current', entry.current);
      });
      prior.forEach(function (item) {
        if (item.value) root.style.setProperty(item.name, item.value, item.priority);
        else root.style.removeProperty(item.name);
      });
      controllers.delete(root);
    });
  }
  function init(scope) {
    if (scope.matches && scope.matches(selector)) mount(scope);
    scope.querySelectorAll(selector).forEach(mount);
  }
  function unload(scope) {
    controllers.forEach(function (dispose, root) {
      if (root === scope || scope.contains(root)) dispose();
    });
  }
  function containsHeader(scope) {
    return (scope.matches && scope.matches('[data-mm]')) || scope.querySelector('[data-mm]');
  }
  window.c4uDirectoryNavigation = { init: init };
  document.addEventListener('shopify:section:load', function (event) {
    if (containsHeader(event.target)) {
      controllers.forEach(function (dispose) { dispose(); });
      init(document);
    } else init(event.target);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    if (containsHeader(event.target)) controllers.forEach(function (dispose) { dispose(); });
    else unload(event.target);
  });
  init(document);
})();
